import { useMutation, useQueryClient } from '@tanstack/react-query';
import { appApiAiCenter } from 'configs/variables';
import useHttpClient from 'hooks/useHttpClient';
import { suspectKeys } from '../keys';

// POST /api/suspects/
// payload: { name }
export function useCreateSuspect({ onSuccess = undefined, onError = undefined } = {}) {
  const { post } = useHttpClient();
  const queryClient = useQueryClient();

  const queryMutation = useMutation({
    mutationKey: suspectKeys.create.queryKey,
    mutationFn: async (payload) => {
      const req = await post({
        url: appApiAiCenter + '/suspects/',
        payload: payload.payload,
      });

      return req;
    },
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: suspectKeys.all._def,
      });

      if (onSuccess) {
        onSuccess(...args);
      }
    },
    onError: (error, ...args) => {
      if (onError) {
        if (!error) return;
        onError(error, ...args);
      }
    },
  });

  return queryMutation;
}
